import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_PROMOTION,
  CREATE_PROMOTION_FAILURE,
  CREATE_PROMOTION_SUCCESS,
  CreatePromotionActionType
} from 'src/redux/promotionsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateMobileListingFlow(action: CreatePromotionActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const {
      motorbikeId,
      highlights,
      photoIds,
      coverPhotoId,
      highlight_1: _highlight1,
      highlight_2: _highlight2,
      highlight_3: _highlight3,
      ...listing
    } = action.payload
    void _highlight1
    void _highlight2
    void _highlight3
    yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${motorbikeId}/mobile_listings`,
      api: 'market-api',
      method: POST,
      params: {
        mobile_listing: {
          ...listing,
          highlights,
          photo_ids: photoIds,
          cover_photo_id: coverPhotoId
        }
      }
    })
    yield put(CREATE_PROMOTION_SUCCESS())
    yield put(SHOW_TOAST({ message: t('my_vehicles.toast_promotion_added') }))
  } catch (error) {
    if (error instanceof Error) {
      yield put(CREATE_PROMOTION_FAILURE(error.message))
    } else {
      yield put(CREATE_PROMOTION_FAILURE())
    }
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateMobileListingSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_PROMOTION, CreateMobileListingFlow)
}
